import { useTranslation } from "react-i18next";

interface PhotoPreviewProps {
  avatarUrl: string | null;
  profile: any;
  onClick: () => void;
}

export const PhotoPreview = ({ avatarUrl, profile, onClick }: PhotoPreviewProps) => {
  return (
    <div 
      className="h-24 w-24 cursor-pointer transition-transform hover:scale-105 rounded-lg overflow-hidden"
      onClick={onClick}
    >
      {avatarUrl ? (
        <img 
          src={avatarUrl} 
          alt={profile?.full_name || 'Profile'} 
          className="h-full w-full object-cover"
        />
      ) : (
        <div className="h-full w-full bg-muted flex items-center justify-center">
          <span className="text-2xl font-semibold text-muted-foreground">
            {profile?.full_name?.[0] || '?'}
          </span>
        </div>
      )}
    </div>
  );
};